import { addDisplayName, addProps, flowMax } from 'ad-hok'
import { FC } from 'react'
import { createUseStyles } from 'react-jss'
import cx from 'classnames'
import { formatDecimalUsd } from 'shared/src/utils/formatting'

import { SANS_SERIF_FONT_FAMILY, SERIF_FONT_FAMILY } from 'components/styles'

const useStyles = createUseStyles({
  title: {
    fontFamily: SERIF_FONT_FAMILY,
    fontSize: 36,
    fontWeight: 700,
    lineHeight: '140%',
    letterSpacing: 0.4,
    color: '#232323',
  },
  goldText: {
    color: '#CBA67A',
  },
  subtitle: {
    fontFamily: SANS_SERIF_FONT_FAMILY,
    fontSize: 14,
    fontWeight: 700,
    lineHeight: '160%',
    letterSpacing: 0.2,
    color: '#90734F',
    opacity: 0.8,
  },
  headerEarningContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 10,
  },
  dollarSign: {
    fontSize: 24,
  },
})

interface Props {
  amount: number
  label: string
  gold?: boolean
}

export const Balance: FC<Props> = flowMax(
  addDisplayName('Balance'),
  addProps(() => ({
    classes: useStyles(),
  })),
  ({ amount, label, gold, classes }) => (
    <div className={classes.headerEarningContainer}>
      <span className={cx(classes.title, gold && classes.goldText)}>
        <span className={classes.dollarSign}>$</span>
        {formatDecimalUsd(amount)}
      </span>
      <span className={classes.subtitle}>{label}</span>
    </div>
  )
)
